export default [

     {
          path: '/language',
          name: 'Language',
          component: () => import("@/views/Page/Language/Language.vue"),
           meta: {
               title: 'Cyber Mode | Language',
          },
     }
];